function HighlightedText({ text }) {
    return (
        <span className={`font-bold text-blue-300`}>
            {" "}
            {text}</span>
    )
}
export default HighlightedText